import { Carousel } from '../../views/ts/components/Carousel';
import { Collapse } from '../../views/ts/components/Collapse';
import { LazyLoader } from '../../views/ts/components/LazyLoader';
import { Module } from './components/Module';
import { ShapeColumn } from '../twig/components/ShapeColumn';
import { Register } from '../twig/modules/register';
import { Home } from '../twig/modules/home';
(new Carousel()).init();
(new Collapse()).init();
(new LazyLoader()).init();
(new Module()).init();
(new Register()).init();
(new ShapeColumn()).init();
(new Home()).init();
